<script lang="ts" setup>
import type { HTMLAttributes } from "vue"
import { ErrorMessage } from "vee-validate"
import { toValue } from "vue"
import { useI18n } from "vue-i18n"
import { cn } from "../../lib/utils"
import { useFormField } from "./useFormField"

const props = defineProps<{
  class?: HTMLAttributes["class"]
}>()

const { name, formMessageId } = useFormField()
const { t } = useI18n()

function fieldMessage(message: string | undefined) {
  if (!message) return ""
  if (message.startsWith("validation.")) return t(message)
  return message
}
</script>

<template>
  <div class="min-h-5">
    <ErrorMessage
      :id="formMessageId"
      data-slot="form-message"
      :name="toValue(name)"
      v-slot="{ message }"
    >
      <p :class="cn('text-destructive text-sm', props.class)">
        {{ fieldMessage(message) }}
      </p>
    </ErrorMessage>
  </div>
</template>
